import { render, staticRenderFns } from "./bidList.vue?vue&type=template&id=191061d9&scoped=true"
import script from "./bidList.vue?vue&type=script&lang=js"
export * from "./bidList.vue?vue&type=script&lang=js"
import style0 from "./bidList.vue?vue&type=style&index=0&id=191061d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191061d9",
  null
  
)

export default component.exports